module.exports = __webpack_public_path__ + "static/anonymus.0d3aba00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/anonymus.jpg
// module id = 83
// module chunks = 115786611955454 144222737640558 162732527042111 167397148725212